import React, { useState } from "react";
import {
  Grid,
  Typography,
  Card,
  CardContent,
  Container,
  Paper,
  List,
  ListItem,
  ListItemText,
  Box,
  Collapse,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

const DissertationServices: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState<number>(0);

  const otherServices = [
    { title: "Dissertation", route: "/dissertation-writing-services" },
    { title: "Coursework", route: "/coursework-writing" },
    { title: "Data Analytics", route: "/data-analysis-services" },
    { title: "Project writing services", route: "/project-report-writing" },
    { title: "Publication", route: "/publication-services" },
    { title: "Manuscript", route: "/manuscript-preparation" },
    { title: "Research methodology", route: "/research-methodology-services" },
  ];

  const data = {
    icon: "ds6.webp",
    title: "Literature Review",
    image: "ds6.webp",
    description:
      "Improve your academic presentation skills with guided coaching on structure, design, and delivery.",
    additionalInfo: [
      {
        title: "References Collection",
        description:
          "At our company, we specialize in helping students with reference collection for literature reviews in assignment writing. We guide students in identifying credible and relevant scholarly sources, such as journal articles, books, and research papers, that align with their topics. By ensuring that references are properly collected and cited, we help students build a solid foundation for their literature review, enhancing the overall quality, credibility, and academic integrity of their assignments.",

        icon1: "",
        cards: [
          {
            title: "Identifying Credible Sources",

            description:
              "Knowing how to identify credible sources is essential for a strong literature review. This topic covers criteria for evaluating the reliability of sources, including author qualifications, publication reputation, and relevance to the research topic.",
          },
          {
            title: "Using Academic Databases",

            description:
              "Academic databases like JSTOR, PubMed, and Google Scholar are valuable tools for collecting references. This topic guides students on how to effectively navigate these platforms to find high-quality research articles and publications relevant to their assignments.",
          },
          {
            title: "Organizing References",

            description:
              "Properly organizing references is crucial for effective literature reviews. This topic discusses techniques for categorizing and managing sources, using tools like reference management software (e.g., EndNote, Zotero), to streamline the writing process.",
          },
          {
            title: "Citing Sources Correctly",

            description:
              "Correct citation is vital for academic integrity and avoiding plagiarism. This topic explains different citation styles, such as APA, MLA, and Chicago, helping students understand how to accurately reference their sources in the literature review.",
          },
        ],
      },
      {
        title: "Conceptual Framework",
        description:
          "At our company, we help students develop a strong conceptual framework for their literature reviews. This framework outlines key concepts, theories, and variables relevant to their research topic. We guide students in identifying relationships between these concepts, enhancing clarity and direction in their literature reviews and demonstrating a thorough understanding of the subject.",

        icon1: "",
        cards: [
          {
            title: "Defining Key Concepts",

            description:
              "Understanding and defining key concepts is crucial for building a conceptual framework. This topic helps students identify the main ideas relevant to their research and establish clear definitions to guide their literature review.",
          },
          {
            title: "Theoretical Frameworks",

            description:
              "Theoretical frameworks provide a lens through which to analyze research topics. This topic explores various theoretical perspectives, helping students choose appropriate frameworks that align with their research objectives and enhance their literature reviews.",
          },
          {
            title: "Relationships Between Variables",

            description:
              "Identifying relationships between key variables is essential for a strong conceptual framework. This topic discusses how to illustrate these relationships, which can help students articulate the dynamics at play in their research and guide their inquiry.",
          },
          {
            title: "Visual Representation",

            description:
              "A visual representation of the conceptual framework can enhance understanding. This topic covers techniques for creating diagrams or models that depict the relationships between concepts and variables, making the framework more accessible and easier to comprehend.",
          },
        ],
      },
      {
        title: "Theoretical Framework",
        description:
          "At our company, we help students create a comprehensive theoretical framework for their literature reviews. This framework provides a structured approach to analyzing research topics. We guide students in selecting relevant theories that support their studies, ensuring a clear connection to their research questions. By incorporating a strong theoretical framework, students deepen their literature reviews and demonstrate a solid understanding of the theories informing their research.",

        icon1: "",
        cards: [
          {
            title: "Identifying Relevant Theories",

            description:
              "Choosing appropriate theories is essential for a solid theoretical framework. This topic helps students understand how to select theories that align with their research and provide a strong foundation for their analysis.",
          },
          {
            title: "Applying Theories to Research Questions",

            description:
              "Theoretical frameworks should directly support research questions. This topic covers how students can apply chosen theories to their specific research topics, ensuring a clear and cohesive link between theory and inquiry.",
          },
          {
            title: "Comparing Different Theoretical Approaches",

            description:
              "Sometimes multiple theories can apply to a research topic. This topic guides students in comparing different theoretical approaches and determining which best suits their study’s needs, enhancing the depth of their analysis.",
          },
          {
            title: "Integrating Theory with Literature",

            description:
              "A strong theoretical framework should be well-integrated with the existing literature. This topic teaches students how to connect their framework to relevant studies, showing how their research builds on or challenges current knowledge.",
          },
        ],
      },
      {
        title: "Annotated Bibliography",
        description:
          "At our company, we help students create annotated bibliographies for their literature reviews. An annotated bibliography includes a list of sources with brief summaries and evaluations. We guide students in summarizing key findings and assessing the relevance of each source, helping them organize their research and deepen their understanding of the literature to enhance their literature reviews.",

        icon1: "",
        cards: [
          {
            title: "Purpose of an Annotated Bibliography",

            description:
              "Understanding the purpose of an annotated bibliography is crucial. This topic explains how it serves as a tool for summarizing research, evaluating sources, and organizing literature, ultimately aiding in the writing process.",
          },
          {
            title: "Formatting and Structure",

            description:
              "Proper formatting and structure are essential for an effective annotated bibliography. This topic covers different citation styles (like APA, MLA, and Chicago) and the specific format required for annotations, ensuring students present their work correctly.",
          },
          {
            title: "Evaluating Sources",

            description:
              "Evaluating sources is key to creating a meaningful annotated bibliography. This topic teaches students how to assess the credibility, relevance, and quality of their sources, ensuring they include only the most valuable information for their literature review.",
          },
          {
            title: "Writing Effective Annotations",

            description:
              "Writing clear and concise annotations is vital. This topic guides students on how to summarize key points, evaluate the significance of each source, and reflect on its contribution to their research, making their annotated bibliography more insightful and useful.",
          },
        ],
      },
      {
        title: "Theorem Development",
        description:
          "AAt our company, we assist students with theorem development for their literature reviews. This process involves formulating theoretical propositions based on existing research. We help students identify gaps in the literature and build on established theories to create original contributions. By effectively presenting their theorems, students enhance the depth of their literature reviews, showcasing their critical thinking and understanding of the subject.",

        icon1: "",
        cards: [
          {
            title: "Identifying Research Gaps",

            description:
              "Recognizing gaps in existing literature is essential for theorem development. This topic guides students in analyzing current research to find areas that lack sufficient exploration, allowing them to formulate relevant theoretical propositions.",
          },
          {
            title: "Building on Established Theories",

            description:
              "Understanding how to build upon established theories is crucial for developing new theorems. This topic discusses how students can leverage existing theories as a foundation for their original contributions, ensuring their work is grounded in established knowledge.",
          },
          {
            title: "Formulating Theoretical Propositions",

            description:
              "This topic focuses on the process of formulating clear and concise theoretical propositions. It guides students in articulating their ideas effectively, making sure their theorems are logically sound and contribute to the scholarly discourse.",
          },
          {
            title: "Testing and Validating Theorems",

            description:
              "Once a theorem is developed, it’s important to consider how it can be tested and validated. This topic discusses methods for evaluating the robustness of their theoretical propositions, helping students ensure their contributions are credible and meaningful.",
          },
        ],
      },
    ],
  };
  const handleServiceClick = (route: string) => {
    window.location.href = route;
  };

  const handleHeadingClick = (index: number) => {
    setActiveIndex(activeIndex === index ? 0 : index);
  };

  return (
    <Container maxWidth={false} disableGutters>
      <Grid
        container
        spacing={0}
        sx={{
          backgroundColor: "#172554",
          padding: { sm: 0, lg: 3 },
          display: "flex",
          flexDirection: "row-reverse",
        }}
        className="component"
      >
        {/* Left Side - Other Services List (Desktop) and Expandable Headings (Mobile) */}
        <Grid item xs={12} md={3}>
          {/* Desktop View */}
          <Box sx={{ display: { xs: "none", md: "block" } }}>
            <List>
              {data.additionalInfo.map((info, index) => (
                <ListItem
                  button
                  key={index}
                  onClick={() => handleHeadingClick(index)}
                  selected={activeIndex === index}
                  sx={{ color: "white" }}
                >
                  <ListItemText primary={info.title} />
                </ListItem>
              ))}
              <Typography
                sx={{ textAlign: "center", color: "white", fontWeight: "bold" }}
              >
                Our Other Services
              </Typography>
              {otherServices.map((service, index) => (
                <ListItem
                  button
                  key={index}
                  onClick={() => handleServiceClick(service.route)}
                  sx={{ color: "white" }}
                >
                  <ListItemText primary={service.title} />
                </ListItem>
              ))}
            </List>
          </Box>

          {/* Mobile View - Expandable Headings */}
          <Box sx={{ display: { xs: "block", md: "none" } }}>
            {data.additionalInfo.map((info, index) => (
              <Box key={index}>
                <ListItem
                  button
                  onClick={() => handleHeadingClick(index)}
                  sx={{
                    color: "white",
                    borderBottom: "1px solid rgba(255,255,255,0.1)",
                  }}
                >
                  <ListItemText primary={info.title} />
                  <IconButton sx={{ color: "white" }}>
                    {activeIndex === index ? (
                      <ExpandLessIcon />
                    ) : (
                      <ExpandMoreIcon />
                    )}
                  </IconButton>
                </ListItem>
                <Collapse
                  in={activeIndex === index}
                  timeout="auto"
                  unmountOnExit
                >
                  <Box
                    sx={{
                      backgroundColor: "#f3f4f6",
                      color: "black",
                      padding: 2,
                    }}
                  >
                    <Typography variant="body2" sx={{ marginBottom: 2 }}>
                      {info.description}
                    </Typography>
                    {info.cards.map((card, cardIndex) => (
                      <Card
                        key={cardIndex}
                        sx={{
                          marginBottom: 2,
                          backgroundColor: "#172554",
                          color: "white",
                        }}
                      >
                        <CardContent>
                          <Typography variant="h6">
                            <i
                              className="fa-solid fa-circle-check"
                              style={{ color: "#f97316", paddingRight: "10px" }}
                            ></i>
                            {card.title}
                          </Typography>
                          <Typography variant="body2">
                            {card.description}
                          </Typography>
                        </CardContent>
                      </Card>
                    ))}
                  </Box>
                </Collapse>
              </Box>
            ))}
          </Box>
        </Grid>

        {/* Right Side - Dissertation Content (Desktop Only) */}
        <Grid item md={9} sx={{ display: { xs: "none", md: "block" } }}>
          <Paper
            elevation={3}
            sx={{
              padding: 3,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              backgroundColor: "#f3f4f6",
              boxShadow: "none",
              borderRadius: "0px",
            }}
          >
            {activeIndex !== null && (
              <>
                <Typography variant="h5" sx={{ marginBottom: 2 }}>
                  {data.additionalInfo[activeIndex].title}
                </Typography>
                <Box sx={{ marginBottom: 2 }}></Box>
                <Typography sx={{ marginBottom: 4, textAlign: "center" }}>
                  {data.additionalInfo[activeIndex].description}
                </Typography>

                <Grid
                  container
                  direction="column"
                  spacing={2}
                  sx={{
                    backgroundColor: "#172554",
                    color: "white",
                    borderRadius: "4px",
                    maxWidth: { lg: "75%", xs: "100%" },
                  }}
                >
                  {data.additionalInfo[activeIndex].cards.map((card, index) => (
                    <Grid item key={index}>
                      <Card
                        sx={{
                          boxShadow: "none",
                          backgroundColor: "transparent",
                          color: "white",
                        }}
                      >
                        <CardContent
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <Typography variant="h6" color={"white"}>
                            <i
                              className="fa-solid fa-circle-check"
                              style={{ color: "#f97316", paddingRight: "10px" }}
                            ></i>
                            {card.title}
                          </Typography>
                          <Typography variant="body2" textAlign={"center"}>
                            {card.description}
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </>
            )}
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default DissertationServices;
